import React from 'react';

import { Card } from '@lightspeed/flame/Card/Card';
import { Box, Flex } from '@lightspeed/flame/Core';
import { Text, TextLink } from '@lightspeed/flame/Text';

import Format from 'helpers/format';
import { createReactRenderer } from 'helpers/react-renderer';

interface PaymentTileProps {
  type: PaymentTileType;
  amount: number;
  onRemove: () => void;
  onEdit: () => void;
}

export enum PaymentTileType {
  INVOICE_PAYMENT_TILE = 'InvoicePaymentTile',
  DEPOSIT_PAYMENT_TILE = 'DepositPaymentTile',
}

const PaymentTile: React.FC<PaymentTileProps> = ({ type, amount, onRemove, onEdit }) => {
  function getTitle(): string {
    switch (type) {
      case PaymentTileType.INVOICE_PAYMENT_TILE:
        return 'Invoice Payment';
      case PaymentTileType.DEPOSIT_PAYMENT_TILE:
        return 'Deposit';
      default:
        return '';
    }
  }

  return (
    <>
      <Box style={{ borderTop: '1px solid #c4cacc' }}>
        <Card my={3} id="payment-tile">
          <Flex p={2} justifyContent="space-between" flexWrap="wrap">
            <Text fontWeight="bold" fontSize="14px" marginRight={1}>
              {getTitle()}
            </Text>
            <Text data-test="payment-tile-amount">
              <var className="notranslate">{Format.toMoney(amount)}</var>
            </Text>
          </Flex>
          <Flex
            backgroundColor="#F2F5F8"
            justifyContent="flex-end"
            style={{ borderTop: '1px solid #D7DCE1' }}
            p={2}
          >
            <Flex>
              <TextLink fontWeight="bold" mr={2} onClick={() => onEdit()} data-test="edit-payment">
                Edit
              </TextLink>
              <TextLink fontWeight="bold" onClick={() => onRemove()} data-test="remove-payment">
                Remove
              </TextLink>
            </Flex>
          </Flex>
        </Card>
      </Box>
    </>
  );
};

export const renderPaymentTile = (props: PaymentTileProps) => {
  const RenderedComponent = createReactRenderer({
    component: PaymentTile,
    selector: `[data-react-root="${props.type}"]`,
  });

  RenderedComponent.mount({
    props: { ...props },
  });

  return RenderedComponent;
};

export default PaymentTile;
